(function () {
  'use strict';

  angular.module('app').component('invoicePage', invoiceDetailCtrl());

  function invoiceDetailCtrl() {
    return {
      bindings: {},
      controller: InvoiceDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/invoices/invoice-page.component.html',
    };
  }

  InvoiceDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'InvoiceService',
    'LocalStoreService',
  ];

  function InvoiceDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    InvoiceService,
    LocalStoreService
  ) {
    const vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_invoice_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;
    // vm.fromBooking = $routeParams.fromBooking;
    // vm.bookingData = $routeParams.bookingData;
    vm.bookingData = JSON.parse(LocalStoreService.get('bookingData'));
    LocalStoreService.unset('bookingData');

    // Methods
    vm.onInvoiceSaved = onInvoiceSaved;
    vm.onInvoiceCanceled = onInvoiceCanceled;

    // Initializers
    getItem();

    function getItem() {
      if (itemId && !vm.bookingData) {
        // edit
        vm.loadingItem = true;
        InvoiceService.getInvoice(itemId).then(function (data) {
          vm.invoice = data;

          vm.loadingItem = false;
        });
      } else {
        vm.invoice = vm.bookingData ? vm.bookingData : {};
      }
    }

    function onInvoiceSaved(item) {
      $location.path(`/invoices/${item.id}`);
    }

    function onInvoiceCanceled() {
      $location.path('/invoices');
    }
  }
})();
